export default __webpack_public_path__ + "static/media/screen3.110e4783.png";